import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { SIGNAL_PROVIDERS, PROVIDER_COLORS, UNSET_LABEL } from './signalProviders';

const NONE = '__none__';

export const ProviderBadge = ({ provider, testid }) => (provider ? (
  <Badge className="text-xs px-2.5 py-1 border" data-testid={testid}
    style={{ backgroundColor: `${PROVIDER_COLORS[provider]}22`, color: PROVIDER_COLORS[provider], borderColor: `${PROVIDER_COLORS[provider]}55` }}>
    {provider}
  </Badge>
) : <span className="text-xs text-amber-400/90 italic" data-testid={testid}>{UNSET_LABEL}</span>);

export const ProviderSelect = ({ value, onChange, allowUnset = false, placeholder = 'Pilih provider', className = '', testid }) => (
  <Select value={value || (allowUnset ? NONE : '')} onValueChange={(v) => onChange(v === NONE ? '' : v)}>
    <SelectTrigger className={`bg-[hsl(var(--surface))] border-[hsl(var(--border))] text-white ${className}`} data-testid={testid} aria-label="Signal provider">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-[hsl(var(--surface-elevated))] border-[hsl(var(--border))]">
      {allowUnset && <SelectItem value={NONE} className="text-[#9CA3AF]">— {UNSET_LABEL} —</SelectItem>}
      {SIGNAL_PROVIDERS.map((p) => (
        <SelectItem key={p} value={p} className="text-white">
          <span className="flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{ backgroundColor: PROVIDER_COLORS[p] }} />{p}</span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
